import React from "react";

import Layout from "../components/layout"
import SEO from "../components/seo"

import "../styles/resume.scss";

const Page = () => {
  return (
    <Layout>
      <SEO title="Resume" />
      <div className="hp-resume-container">
        <object data="/hariprasath_resume.pdf" type="application/pdf" width="100%" height="100%" />
      </div>
    </Layout>
  )
}

export default Page;
